import * as React from 'react';
import Ghost from '../../components/ghost';

import GraphGhostState from './GraphGhostState';

import './GraphCardGhostState.scss';

const GraphCardGhostState = () => (
    <div className="GraphCardGhostState" data-testid="GraphCardGhostState">
        <div className="GraphCardGhostState-header">
            <Ghost borderRadius={4} height={16} width={56} />
            <Ghost borderRadius={4} className="GraphCardGhostState-headlinePill" height={20} width={96} />
        </div>
        <GraphGhostState />
    </div>
);

export default GraphCardGhostState;
